__webpack_require__.p = "https://assets.worldcubeassociation.org/assets/2153959/packs/";